module.exports = __webpack_public_path__ + "static/media/bars-solid.c36df1ee.svg";